export default function Link(props: {
  href?: string;
  children: preact.ComponentChildren;
  [key: string]: any;
}) {
  const isExternal = props.href && props.href.startsWith('http');

  if (isExternal) {
    return (
      <a href={props.href} target="_blank" rel="noopener noreferrer" {...props}>
        {props.children}
      </a>
    );
  }

  return (
    <a href={props.href} {...props}> {props.children} </a>
  );
}
